<template>
  <div class="cancel-service-page">
    <div v-if="alreadyCancelled" class="state-block">
      <div class="state-icon state-icon--grey">
        <check-circle-icon fill-color="#9ca3af" :size="52" />
      </div>
      <div class="state-title state-title--grey">
        {{ $t("settings.cancelServiceAlready") }}
      </div>
      <div class="state-description">
        {{ $t("settings.cancelServiceAlreadyDesc") }}
      </div>
    </div>

    <div v-else-if="cancelled" class="state-block">
      <div class="state-icon state-icon--green">
        <check-circle-icon fill-color="#22c55e" :size="52" />
      </div>
      <div class="state-title state-title--green">
        {{ $t("settings.cancelServiceSuccess") }}
      </div>
      <div class="state-description">
        {{ $t("settings.cancelServiceSuccessDesc") }}
      </div>
    </div>

    <div v-else class="state-block">
      <div class="state-icon state-icon--red">
        <close-circle-icon fill-color="#ef4444" :size="52" />
      </div>
      <div class="state-title">
        {{ $t("settings.cancelServiceTitle") }}
      </div>
      <div class="state-description">
        {{ $t("settings.cancelServiceDescription") }}
      </div>
      <div class="cancel-button-wrapper">
        <itserve-button
          @click="handleCancel"
          :disabled="loading"
          :value="$t('stripe.unButton')"
          btnStyle="primary"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CloseCircleIcon from "vue-material-design-icons/CloseCircle";
import CheckCircleIcon from "vue-material-design-icons/CheckCircle";
import ItserveButton from "@/components/forms/ItserveButton";
import Dialog from "vant/lib/dialog/index";

export default {
  name: "CancelService",
  components: {
    CloseCircleIcon,
    CheckCircleIcon,
    ItserveButton,
  },
  data() {
    return {
      loading: false,
      cancelled: false,
      alreadyCancelled: false,
    };
  },
  computed: {
    statusSub() {
      return this.$store.state.Auth.status_sub;
    },
    stripeSubscriptionData() {
      return {
        loading: false,
        mode: "subscription",
        email: this.$store.state.Settings.settings?.email,
        user_id: this.$store.state.Auth.user_id,
      };
    },
  },
  async created() {
    await this.$store.dispatch("Settings/getSettings");
    await this.$store.dispatch("Auth/getSubscriptionStatus");
    if (this.statusSub === 0) {
      this.alreadyCancelled = true;
    }
  },
  methods: {
    async handleCancel() {
      Dialog.confirm({
        title: this.$t("stripe.dialogPayMessage"),
        message: this.$t("stripe.dialogPayQuestion"),
        cancelButtonText: this.$t("stripe.dialogCancel"),
        confirmButtonText: this.$t("stripe.dialogConfirm"),
      })
        .then(async () => {
          await this.cancelSubscription();
        })
        .catch(() => {});
    },

    async cancelSubscription() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "Payment/cancelSubscription",
          this.stripeSubscriptionData
        );
        this.$store.commit("Auth/SET_USER_STATUS", 0);
        this.$store.commit("Auth/SET_USER_STATUS_SUB", 0);
        this.cancelled = true;
      } catch (error) {
        if (error?.response?.status === 500) {
          this.alreadyCancelled = true;
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.cancel-service-page {
  padding: 60px 24px;
  text-align: center;
}

.state-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.state-icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.state-icon--red {
  background-color: #fef2f2;
}

.state-icon--green {
  background-color: #f0fdf4;
}

.state-icon--grey {
  background-color: #f3f4f6;
}

.state-title {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 12px;
}

.state-title--green {
  color: #4ade80;
}

.state-title--grey {
  color: #ffffff;
}

.state-description {
  font-size: 15px;
  color: #ffffff;
  line-height: 1.6;
  margin-bottom: 8px;
  max-width: 280px;
}

.cancel-button-wrapper {
  max-width: 280px;
  width: 100%;
  margin-top: 16px;
}
</style>
